const pageFlows = {
  HowItWorks: 0,
  CurrentTenantEndDate: 1,
  CurrentTenantEndDateShortened: 2,
  CurrentTenantM2MShortened: 3,
  NewTenantInfo: 4,
  NewTenantDueDate: 5,
  NewTenantTermLength: 6,
  NewTenantRentAmount: 7,
  NewTenantMoveInCostsPage: 8,
  NewTenantExperian: 9,
  NewTenantConfirmation: 10,
};

export { pageFlows };
